import React from "react";
import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";

const DetailDiscountsTitleColumns = () => (
    <>
        <GridTable.Data columnStart={1} alignX="center" rowStart={1} rowWidth={1}>
            <I18n component="span" id="discounts.tableHeader.idBatch" />
        </GridTable.Data>
        <GridTable.Data columnStart={2} alignX="center" rowStart={1} rowWidth={1}>
            <I18n component="span" id="discounts.tableHeader.applicant" />
        </GridTable.Data>
        <GridTable.Data columnStart={3} alignX="center" rowStart={1} rowWidth={1}>
            <I18n component="span" id="discounts.tableHeader.issue" />
        </GridTable.Data>
        <GridTable.Data columnStart={4} alignX="center" rowStart={1} rowWidth={1}>
            <I18n component="span" id="discounts.tableHeader.totalAmount" />
        </GridTable.Data>
        <GridTable.Data columnStart={5} alignX="center" rowStart={1} rowWidth={1}>
            <I18n component="span" id="discounts.tableHeader.discountDiscount" />
        </GridTable.Data>
        <GridTable.Data columnStart={6} alignX="center" rowStart={1} rowWidth={1}>
            <I18n component="span" id="discounts.tableHeader.status" />
        </GridTable.Data>
        <GridTable.Data columnStart={7} alignX="center" rowStart={1} rowWidth={1} />
    </>
);
export default DetailDiscountsTitleColumns;
